import moment from "moment";

const tzNames = {
    EST: 'Eastern Standard Time',
    EDT: 'Eastern Daylight Time',
    CST: 'Central Standard Time',
    CDT: 'Central Daylight Time',
    MST: 'Mountain Standard Time',
    MDT: 'Mountain Daylight Time',
    PST: 'Pacific Standard Time',
    PDT: 'Pacific Daylight Time',
};

export function getTimezoneName(tz) {
    if (!tz) {
        return 'Unknown';
    }
    const abbreviation = moment.tz(tz).zoneName();
    if (!abbreviation) {
        return 'Unknown';
    }
    if (!tzNames[abbreviation]) {
        return abbreviation;
    }
    return `${tzNames[abbreviation]} (${abbreviation})`;
}
